import React from 'react';
import { Card, Result, Typography } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

const { Paragraph } = Typography;

const AlertManagement: React.FC = () => {
  const featureDisabled = useSelector((state: RootState) => state.alert.featureDisabled);

  return (
    <div>
      <div
        style={{
          marginBottom: 16,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <h1 style={{ margin: 0 }}>告警管理</h1>
      </div>

      <Card>
        <Result
          icon={<BellOutlined style={{ color: '#faad14' }} />}
          title="告警接口暂未启用"
          subTitle="当前版本中，告警列表与统计接口已下线。"
          extra={
            <Paragraph style={{ marginBottom: 0, color: 'rgba(0,0,0,0.65)' }}>
              {featureDisabled
                ? '如需查看告警信息，请联系管理员或等待后续版本更新。'
                : '告警功能已恢复，可在后续版本查看相关数据。'}
            </Paragraph>
          }
        />
      </Card>
    </div>
  );
};

export default AlertManagement;
